export default "__VITE_ASSET__CxnnOV4P__"